module.exports = __webpack_public_path__ + "img/empty.376daa05.png";